import React from 'react';
import {Button} from '@mui/material';
import {MyAppointmentsEnum} from 'presentation/constants';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {translations} from 'presentation/translations-new';
import {Navigate} from 'react-router-dom';
import {useTelehealthConfirmationBooking} from './hooks/useTelehealthConfirmationBooking';
import {TelehealthConfirmationBookingContent} from './components/TelehealthConfirmationBookingContent';
import {TelehealthConfirmationBookingContentNew} from './components/TelehealthConfirmationBookingContentNew';

const {loadError, loading} = translations['pt-br'].commons;

const {confirmationBooking, seeMyAppointments} = translations['pt-br'].privateFlow.bookingFlow;

export function TelehealthConfirmationBooking() {
	const {
		goToMyAppointments,
		confirmedBookAppointment,
		appointmentsListLoading,
		appointmentsListError,
		refresh,
		showNewConfirmationPage,
	} = useTelehealthConfirmationBooking();

	if (appointmentsListLoading) {
		return (
			<BookingLoadingState
				pageTitle={confirmationBooking}
				loadingText={loading}
				hideBackBtn
			/>
		);
	}

	if (!confirmedBookAppointment) {
		return <Navigate to={MyAppointmentsEnum.MY_APPOINTMENTS} />;
	}

	if (appointmentsListError) {
		return (
			<BookingErrorState
				pageTitle={confirmationBooking}
				errorTitle={loadError}
				handleBack={goToMyAppointments}
				handleRefresh={refresh}>
				<Button
					size="large"
					sx={{mx: 'auto', mt: 2, width: 'min-content'}}
					onClick={goToMyAppointments}>
					{seeMyAppointments}
				</Button>
			</BookingErrorState>
		);
	}

	return showNewConfirmationPage ? (
		<TelehealthConfirmationBookingContentNew
			bookedAppointment={confirmedBookAppointment}
			goToMyAppointments={goToMyAppointments}
		/>
	) : (
		<TelehealthConfirmationBookingContent
			bookedAppointment={confirmedBookAppointment}
			goToMyAppointments={goToMyAppointments}
		/>
	);
}
